import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  timeGap: number;
}

const initialState: InitStata = {
  timeGap: 0,
};

const customerSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
    changeTimeGap: (state = initialState, action: PayloadAction<number>) => {
      state.timeGap = action.payload;
    },
  },
});

// 导出action
export const { changeTimeGap } = customerSlice.actions;

export default customerSlice.reducer;
